<template>
  <div class="chart-cell">
    <DxPopup
      :title="this.$t('general.columnChooser')"
      :width="250"
      :height="350"
      :resize-enabled="true"
      :shading="false"
      :show-close-button="true"
      :drag-enabled="true"
      :hide-on-outside-click="true"
      :visible="visible"
      @hiding="onHiding"
      @option-changed=onOptionChangedPopup
    >
      <DxPosition at="center center" my="center center" />

      <DxList
        :ref="listRefKey"
        :data-source="columnsList"
        display-expr="caption"
        key-expr="id"
        selection-mode="multiple"
        page-load-mode="scrollBottom"
        :show-selection-controls="true"
        :selected-items="selectedItems"
        @option-changed=onOptionChanged
      />
    </DxPopup>
  </div>
</template>
<script>
import DxPopup, { DxPosition } from "devextreme-vue/popup";
import DxList from "devextreme-vue/list";
import { getColumnId } from "@/components/column-chooser/grid-columns";

// Caption только отображаемый текст; идентификация столбца обрабатывается отдельно с помощью функции getColumnId
function getColumnText(column) {
  return String((column && (column.caption || column.dataField || column.name)) || "");
}

// DxList работает с объектами элементов, поэтому выбор осуществляется по стабильному идентификатору, а не по переведенному заголовку
function mapColumnToListItem(column) {
  return {
    id: getColumnId(column),
    dataField: column && column.dataField,
    name: column && column.name,
    caption: getColumnText(column),
    // не следует называть это поле "visible": DevExtreme List рассматривает item.visible=false как скрытый элемент списка.
    columnVisible: column.visible
  };
}

const listRefKey = "my-list";

export default {
  props: {
    visible: Boolean,
    columns: {
      type: Array,
      default: () => []
    },
    onApply: Function,
    onHiding: Function,
  },
  components: {
    DxPopup,
    DxPosition,
    DxList,
  },
  data() {
    return {
      listRefKey,
      columnsList: [],
      selectedItems: [],
    };
  },
  computed: {
    list: function () {
      return this.$refs[listRefKey].instance;
    },
  },
  methods: {
    onOptionChangedPopup(e) {
      if (e.fullName === 'visible' && e.value && this.columns.length !== 0) {
        this.columnsList = this.columns.map((column) => mapColumnToListItem(column));
        this.selectedItems = this.columnsList.filter((item) => item.columnVisible);
      }
    },
    onOptionChanged(e) {
      if (e.name === 'selectedItems') {
        const selectedItems = this.list.option("selectedItems");

        if (selectedItems.length >= 1) {
          let changes = [];
          // для поддержки дублирующихся и локализованных caption необходимо сравнивать выбранные столбцы по идентификатору
          const selectedColumnIds = new Set(selectedItems.map((item) => item.id));

          this.columns.forEach((column) => {
            const isSelected = selectedColumnIds.has(getColumnId(column));
            if (column.visible !== isSelected) {
              changes.push({
                ...column,
                visible: isSelected,
              });
            }
          });
          this.onApply(changes);
        } else {
          this.selectedItems = e.previousValue;
        }
      }
    }
  }
};
</script>